

import router from '@/router';
import { Message } from 'element-ui';
export  function isReturn(code) {
    if(code === -1){
        sessionStorage.removeItem('tokenInfo')
        Message.error('登录已过期，请重新登录')
        router.push("/");
    }else{
        // Message.success('查询成功')
        return
    }
    return
}







// WEBPACK FOOTER //
// ./src/utils/retnue.js